import { useStore } from '@nanostores/react';

export const Billing = () => {
  const user = useStore($user);
  const [openBillingPlansDialog, setOpenBillingPlansDialog] = useState(false);

  return (
    <div>
      <div id="title">
        <p className="flex flex-1 items-center justify-start text-xl font-semibold tracking-tight">
          Billing
        </p>
        <p className="text-sm text-muted-foreground">
          Manage your subscription plan
        </p>
      </div>
      <div className="mt-6">
        <div className="flex h-[150px] w-full flex-1 justify-start gap-3 rounded-lg border bg-muted p-6">
          <div className="flex w-[70%] flex-1 flex-col justify-start">
            <p className="text-xl font-semibold">Rally Enterprise</p>
            <p className="text-sm text-muted-foreground">
              This is an early access enterprise plan.
            </p>

            {/* <p className="mt-1 flex items-start text-xs text-muted-foreground">
              <Info className="mr-1 h-4 w-4" /> You are enrolled to Rally
              Enterprise early access plan. It includes a free trial period of 7
              days, then billed $249 / month.
            </p> */}
            <p className="mt-8 text-sm text-muted-foreground">
              Need any help? Contact us at{' '}
              <span className="text-blue-600">
                <a href="mailto:sales@tennisfinance.com">
                  sales@tennisfinance.com
                </a>
              </span>
            </p>
            {/* <p className="mt-1 text-sm text-red-600 underline underline-offset-4">
              Cancel Subscription
            </p> */}
          </div>
          <div className="">
            <p className="text-xl font-semibold">$249 /mo</p>
          </div>
          {/* <div className="" onClick={() => setOpenBillingPlansDialog(true)}>
            <Button className="">Upgrade Plan</Button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
